import { render, staticRenderFns } from "./daily-allowance-form.vue?vue&type=template&id=11aa6264&"
import script from "./daily-allowance-form.vue?vue&type=script&lang=js&"
export * from "./daily-allowance-form.vue?vue&type=script&lang=js&"
import style0 from "./daily-allowance-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports